import { render, staticRenderFns } from "./WizardThroughputKdvBso.vue?vue&type=template&id=aa020512&"
import script from "./WizardThroughputKdvBso.vue?vue&type=script&lang=js&"
export * from "./WizardThroughputKdvBso.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports